import { render, staticRenderFns } from "./equipment-group-equipment-page.vue?vue&type=template&id=1fab0504&scoped=true&"
import script from "./equipment-group-equipment-page.vue?vue&type=script&lang=js&"
export * from "./equipment-group-equipment-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fab0504",
  null
  
)

export default component.exports